import React from "react";

import * as S from "./ReferencedNetworkSection.style";

const ReferencedNetworkSection = () => {
  return (
    <>
      <S.ReferencedNetworkContainer>
        <S.ReferencedNetworkContent>
          <S.ReferencedNetworkHeader className="container">
            <S.ReferencedNetworkTitle>
              Rede referenciada
            </S.ReferencedNetworkTitle>

            <S.ReferencedNetworkDescription>
              Utilize os campos abaixo para encontrar o profissional mais perto
              de você:
            </S.ReferencedNetworkDescription>
          </S.ReferencedNetworkHeader>

          <S.ReferencedNetworkIframeWrapper>
            <iframe
              src="https://wwwt.connectmed.com.br/saudeweb/redeCaixa/p2/12"
              width="100%"
              height="700px"
              title="connectmed"
            />
          </S.ReferencedNetworkIframeWrapper>

          <S.ReferencedNetworkFooter className="container">
            Para saber quais profissionais/clínicas/hospitais não fazem mais
            parte da nossa rede referenciada,{" "}
            <a
              href="https://wwwt.connectmed.com.br/saudeweb/redeatendimento/atualizacao/?codOpa=12&language=pt"
              target="_blank"
              rel="noreferrer"
            >
              clique aqui.
            </a>
          </S.ReferencedNetworkFooter>
        </S.ReferencedNetworkContent>
      </S.ReferencedNetworkContainer>
    </>
  );
};

export default ReferencedNetworkSection;
